module.exports = __webpack_public_path__ + "static/media/background.a69a0562.png";